import React from 'react';
import Store from '../../store/Store';
import { IconDownload } from '../Icons';

export interface DownloadButtonProps {
	label?: string;
	children?: React.ReactNode;
	onClick?: () => void;
	url?: string;
	name?: string;
	info?: string;
	small?: boolean;
	self?: boolean;
	['data-pw']?: string;
}

export const DownloadButton: React.FC<DownloadButtonProps> = props => {
	const handleDownload = () => {
		if (props.onClick) return props.onClick();

		if (!props.url) return;

		props.info && Store.setPopupMessage('info', 'Download', props.info, 0);

		console.log('---download:', props.name ?? props.url, '...');
		const link = document.createElement('a');
		link.href = props.url;
		link.target = props.self ? '_self' : '_blank';
		link.download = props.name ?? 'default-filename';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		props.info &&
			Store.setPopupMessage('ok', 'Download erfolgreich! ', props.info);
	};

	return (
		<button
			className="flex gap-2 h-10 items-center"
			data-pw={props['data-pw'] ?? 'button-download'}
			onClick={() => handleDownload()}
		>
			<IconDownload />
			<span className="mr-auto text-base font-semibold text-[#0063A3] underline">{props.label ?? props.children}</span>
		</button>
	);
};
